import { render, staticRenderFns } from "./ProfileTitle.vue?vue&type=template&id=46e9a8a1&scoped=true"
import script from "./ProfileTitle.vue?vue&type=script&lang=js"
export * from "./ProfileTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e9a8a1",
  null
  
)

export default component.exports